import { Routes, UrlMatcher, UrlSegment } from '@angular/router';

/** Casa `/400`, `/401`, `/403`, `/500`… (un solo segmento 4xx/5xx) y lo expone como parámetro `code`. */
export const httpStatusMatcher: UrlMatcher = (segments: UrlSegment[]) =>
  segments.length === 1 && /^[45]\d{2}$/.test(segments[0].path)
    ? { consumed: segments, posParams: { code: segments[0] } }
    : null;

const loadErrorPage = () =>
  import('./pages/error-page/error-page.component').then((m) => m.ErrorPageComponent);

export const routes: Routes = [
  { path: 'error/:code', loadComponent: loadErrorPage },
  { matcher: httpStatusMatcher, loadComponent: loadErrorPage },
];
